/*Flexi Box Bundle Script Code - Final with Collection Restriction*/

document.addEventListener('DOMContentLoaded', function () {

  const checkboxes = document.querySelectorAll("input[type='checkbox']");
  const quantityInputs = document.querySelectorAll('.quantity-input');
  const submitBtn = document.getElementById('submit-btn');
  const counterEl = document.getElementById('total_product_count');
  const flexiBoxForm = document.getElementById('flexi-box-form');

  checkboxes.forEach(checkbox => checkbox.disabled = false);

  let totalQuantitySelected = 0;

  function calculateTotalQuantity() {
    let total = 0;
    quantityInputs.forEach(input => total += parseInt(input.value) || 0);
    return total;
  }

  function updateBubbleCounter() {
    if (!counterEl) return;

    totalQuantitySelected = calculateTotalQuantity();
    const isLimitReached = (totalQuantitySelected === mandatoryProducts);

    counterEl.classList.remove('limit-reached', 'active-limit-reached');

    if (isLimitReached) {
      counterEl.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="check-icon" width="11" height="9" viewBox="0 0 11 9"><path d="M9.66802 1.37429L4.48642 7.85309L0.416016 4.46069L1.18402 3.53909L4.31362 6.14669L8.73201 0.625488L9.66802 1.37429Z" fill="#fff"/></svg>`;
      counterEl.classList.add('active-limit-reached');
    } else if (totalQuantitySelected > 0) {
      counterEl.textContent = totalQuantitySelected;
    } else {
      counterEl.textContent = '';
    }
  }

  const initProdValues = {};
  checkboxes.forEach(checkbox => {
    initProdValues[checkbox.id] = checkbox.value.trim();
  });

  function showAddedIndicators(productInfo) {
    productInfo.querySelectorAll(".added_to_cart, .product_counter").forEach(el => el.classList.remove("hidden"));
    productInfo.querySelectorAll(".one-fourth-column").forEach(el => el.classList.add("is-active"));
  }

  function hideAddedIndicators(productInfo) {
    productInfo.querySelectorAll(".added_to_cart, .product_counter").forEach(el => el.classList.add("hidden"));
    productInfo.querySelectorAll(".one-fourth-column").forEach(el => el.classList.remove("is-active"));
  }

  function showNotificationMessage(msg) {
    document.querySelectorAll(".message-bar").forEach(bar => {
      bar.classList.remove("is-hidden");
      const span = bar.querySelector("p span");
      if (span) span.textContent = msg;
      setTimeout(() => {
        bar.classList.add("is-hidden");
        if (span) span.textContent = "";
      }, 2000);
    });
  }

  /* ===== COLLECTION CHECK ===== */

  function isCollectionAlreadySelected(collectionName, currentItem) {
    const items = document.querySelectorAll(`.collection-item[data-collection="${collectionName}"]`);

    for (let item of items) {
      if (item !== currentItem) {
        const qtyInput = item.querySelector('.quantity-input');

        if (qtyInput && parseInt(qtyInput.value) > 0) {
          return true;
        }
      }
    }

    return false;
  }

  function updateCollectionStates() {

    const collections = {};
    const allCollectionItems = document.querySelectorAll('.collection-item');

    // Count selected qty collection-wise
    allCollectionItems.forEach(item => {

      const collection = item.getAttribute('data-collection');
      const qty = parseInt(item.querySelector('.quantity-input')?.value) || 0;

      if (!collections[collection]) {
        collections[collection] = 0;
      }

      collections[collection] += qty;
    });

    // FIRST COLLECTION MUST LOGIC
    let firstCollectionName = null;

    if (window.first_collection_must === true) {

      const firstItem = document.querySelector('.collection-item');

      if (firstItem) {
        firstCollectionName = firstItem.getAttribute('data-collection');
      }
    }

    const firstCollectionSelected =
      firstCollectionName &&
      collections[firstCollectionName] >= 1;

    allCollectionItems.forEach(item => {

      const collection = item.getAttribute('data-collection');
      const checkbox = item.querySelector("input[type='checkbox']");
      const qtyInput = item.querySelector('.quantity-input');

      const isSelected =
        qtyInput &&
        parseInt(qtyInput.value) > 0;

      // SAME COLLECTION RESTRICTION
      if (collections[collection] >= 3 && !isSelected) {

        checkbox.disabled = true;
        item.classList.add('disabled-item');

      } else {

        checkbox.disabled = false;
        item.classList.remove('disabled-item');
      }

      // FIRST COLLECTION MUST RESTRICTION
      if (
        window.first_collection_must === true &&
        collection !== firstCollectionName &&
        !firstCollectionSelected
      ) {

        checkbox.disabled = true;
        item.classList.add('disabled-item');
      }

    });
  }

  /* ===== CHECKBOX CLICK ===== */

  checkboxes.forEach(checkbox => {

    checkbox.addEventListener("click", function () {

      const productInfo = this.closest(".collection-item");

      if (!productInfo) return;

      const collectionName = productInfo.getAttribute('data-collection');

      // if (isCollectionAlreadySelected(collectionName, productInfo)) {

      //   showNotificationMessage("Only 1 product allowed per collection");

      //   this.checked = false;

      //   return;
      // }

      if (this.checked) {

        this.closest('.add-to-box').classList.add('hidden');

        const quantitySelector = productInfo.querySelector('.quantity-selector');

        if (quantitySelector) {

          quantitySelector.classList.remove('hidden');

          const quantityInput = quantitySelector.querySelector('.quantity-input');

          if (quantityInput) {

            quantityInput.value = 1;

            createLineItems(quantityInput);
          }
        }

        showAddedIndicators(productInfo);

        updateAllStates();
      }
    });
  });

  /* ===== QUANTITY HANDLER (MAX = 1) ===== */

  document.addEventListener('click', function(e) {

    const isPlus = e.target.classList.contains('quantity-plus');
    const isMinus = e.target.classList.contains('quantity-minus');

    if (!isPlus && !isMinus) return;

    const input = isPlus
      ? e.target.previousElementSibling
      : e.target.nextElementSibling;

    if (!input) return;

    let currentValue = parseInt(input.value) || 0;

    if (isPlus && currentValue < 1) {

      input.value = 1;

      createLineItems(input);

      updateAllStates();
    }

    if (isMinus && currentValue === 1) {

      resetProductToCheckbox(input);
    }
  });

  function resetProductToCheckbox(input) {

    input.value = 0;

    const productInfo = input.closest('.collection-item');

    input.closest('.quantity-selector').classList.add('hidden');

    const checkbox = productInfo.querySelector("input[type='checkbox']");

    checkbox.checked = false;

    checkbox.closest('.add-to-box').classList.remove('hidden');

    hideAddedIndicators(productInfo);

    removeAllLineItems(input);

    updateAllStates();
  }

  function createLineItems(input) {

    const property = input.getAttribute('data-property');
    const itemId = input.getAttribute('data-id');

    removeAllLineItems(input);

    const hiddenInput = document.createElement('input');

    hiddenInput.type = 'hidden';
    hiddenInput.name = `properties[_ITEM${itemId}_1]`;
    hiddenInput.value = property;
    hiddenInput.className = `line-item-${itemId}`;

    flexiBoxForm.appendChild(hiddenInput);
  }

  function removeAllLineItems(input) {

    const itemId = input.getAttribute('data-id');

    document.querySelectorAll(`.line-item-${itemId}`).forEach(item => item.remove());
  }

  function updateSubmitButton() {

    if (!submitBtn) return;

    const total = calculateTotalQuantity();

    submitBtn.style.display =
      (total === mandatoryProducts)
        ? 'inline-block'
        : 'none';
  }

  function updateAllStates() {

    updateBubbleCounter();

    updateSubmitButton();

    updateCollectionStates();
  }

  updateAllStates();

});